var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { colors, cssThemedValue, cssVarsThemed, Typography as T, typographyCss, } from '@creditornot/cb-ingredients';
import { createCssVars, pxToRem } from '@creditornot/cb-utils';
var colorCssVars = createCssVars([
    'background',
    'segmentBackground',
    'segmentDivider',
    'segmentLabelPressed',
    'segmentBoxShadow',
]);
var Root = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  ", "\n\n  box-sizing: border-box;\n  user-select: none;\n  z-index: 0;\n\n  position: relative;\n  display: ", ";\n  align-items: center;\n  height: 36px;\n  padding: 2px;\n  border-radius: 8px;\n  background-color: ", ";\n  font-size: ", ";\n  font-weight: 500;\n  cursor: ", ";\n"], ["\n  ", "\n\n  ", "\n\n  box-sizing: border-box;\n  user-select: none;\n  z-index: 0;\n\n  position: relative;\n  display: ", ";\n  align-items: center;\n  height: 36px;\n  padding: 2px;\n  border-radius: 8px;\n  background-color: ", ";\n  font-size: ", ";\n  font-weight: 500;\n  cursor: ", ";\n"])), typographyCss.baseFontFamily, cssVarsThemed({
    background: {
        light: colors.pepper8,
        dark: colors.salt12,
    },
    segmentBackground: {
        light: colors.salt100,
        dark: colors.salt24,
    },
    segmentDivider: {
        light: colors.pepper8,
        dark: colors.salt12,
    },
    segmentLabelPressed: {
        light: colors.pepper80,
        dark: colors.salt88,
    },
    segmentBoxShadow: {
        light: '0 1px 1px 0 rgba(0, 0, 0, 0.12), 0 0 1px 0 rgba(0, 0, 0, 0.06)',
        dark: 'none',
    },
}), function (_a) {
    var $fixedWidths = _a.$fixedWidths;
    return ($fixedWidths ? 'flex' : 'inline-flex');
}, colorCssVars.background, pxToRem(14), function (_a) {
    var $disabled = _a.$disabled;
    return ($disabled ? 'not-allowed' : 'pointer');
});
var FocusIndicator = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  border-radius: 8px;\n  border: 2px solid ", ";\n  z-index: 4;\n"], ["\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  border-radius: 8px;\n  border: 2px solid ", ";\n  z-index: 4;\n"])), cssThemedValue('a11yFocusIndicator'));
var Segment = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  /* normalize */\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  border: none;\n  position: relative;\n  overflow: visible;\n  text-transform: none;\n\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  box-sizing: border-box;\n  user-select: none;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 32px;\n  flex: ", ";\n  padding: ", ";\n  text-align: center;\n  outline: none;\n  color: ", ";\n  white-space: nowrap;\n  &:hover {\n    color: ", ";\n  }\n  &:active {\n    color: ", ";\n  }\n\n  transition: color 50ms linear;\n\n  & + &::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    height: 16px;\n    width: 1px;\n    background: ", ";\n  }\n  ", "\n\n  :focus-visible ", " {\n    visibility: visible;\n  }\n"], ["\n  /* normalize */\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  border: none;\n  position: relative;\n  overflow: visible;\n  text-transform: none;\n\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  box-sizing: border-box;\n  user-select: none;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 32px;\n  flex: ", ";\n  padding: ", ";\n  text-align: center;\n  outline: none;\n  color: ", ";\n  white-space: nowrap;\n  &:hover {\n    color: ", ";\n  }\n  &:active {\n    color: ", ";\n  }\n\n  transition: color 50ms linear;\n\n  & + &::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    height: 16px;\n    width: 1px;\n    background: ", ";\n  }\n  ", "\n\n  :focus-visible ", " {\n    visibility: visible;\n  }\n"])), function (_a) {
    var $fixedWidths = _a.$fixedWidths;
    return ($fixedWidths ? 1 : 'none');
}, function (_a) {
    var $fixedWidths = _a.$fixedWidths;
    return ($fixedWidths ? '0' : '0 24px');
}, function (_a) {
    var $active = _a.$active, $disabled = _a.$disabled;
    if ($active) {
        return 'transparent';
    }
    if ($disabled) {
        return cssThemedValue('textTertiary');
    }
    return cssThemedValue('textSecondary');
}, function (_a) {
    var $active = _a.$active, $disabled = _a.$disabled;
    return !$active && !$disabled && cssThemedValue('textPrimary');
}, function (_a) {
    var $active = _a.$active, $disabled = _a.$disabled;
    if (!$disabled && !$active) {
        return colorCssVars.segmentLabelPressed;
    }
    return '';
}, colorCssVars.segmentDivider, function (_a) {
    var $active = _a.$active;
    return $active && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      & + &::before {\n        background-color: transparent;\n        transition: background-color 0ms;\n        transition-delay: 200ms;\n      }\n    "], ["\n      & + &::before {\n        background-color: transparent;\n        transition: background-color 0ms;\n        transition-delay: 200ms;\n      }\n    "])));
}, FocusIndicator);
var ItemLabel = styled(T.Body3)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  z-index: 1;\n"], ["\n  z-index: 1;\n"])));
var ItemOverlayLabel = styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-weight: 700;\n  color: ", ";\n  ", "\n  transition: opacity 100ms linear;\n  opacity: ", ";\n  z-index: 3;\n"], ["\n  ", "\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-weight: 700;\n  color: ", ";\n  ", "\n  transition: opacity 100ms linear;\n  opacity: ", ";\n  z-index: 3;\n"])), typographyCss.Body3, function (_a) {
    var $disabled = _a.$disabled;
    return $disabled ? cssThemedValue('textTertiary') : cssThemedValue('textPrimary');
}, function (_a) {
    var $disabled = _a.$disabled;
    return !$disabled && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      &:active {\n        color: ", ";\n      }\n    "], ["\n      &:active {\n        color: ", ";\n      }\n    "])), colorCssVars.segmentLabelPressed);
}, function (_a) {
    var $show = _a.$show;
    return ($show ? 1 : 0);
});
var SegmentBackground = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  box-sizing: border-box;\n  position: absolute;\n  height: 32px;\n  z-index: 2;\n\n  background-color: ", ";\n  box-shadow: ", ";\n  border-radius: 8px;\n\n  left: ", ";\n  width: ", ";\n  transition: ", ";\n"], ["\n  box-sizing: border-box;\n  position: absolute;\n  height: 32px;\n  z-index: 2;\n\n  background-color: ", ";\n  box-shadow: ", ";\n  border-radius: 8px;\n\n  left: ", ";\n  width: ", ";\n  transition: ", ";\n"])), colorCssVars.segmentBackground, colorCssVars.segmentBoxShadow, function (_a) {
    var $left = _a.$left;
    return "".concat($left, "px");
}, function (_a) {
    var $width = _a.$width;
    return "".concat($width, "px");
}, function (_a) {
    var $duration = _a.$duration;
    return "left ".concat($duration, " ease-in-out, width ").concat($duration, " ease-in-out");
});
var SegmentedControl = function (_a) {
    var className = _a.className, disabled = _a.disabled, fixedWidths = _a.fixedWidths, onChange = _a.onChange, options = _a.options, style = _a.style, value = _a.value;
    var activeEl = useRef(null);
    var _b = __read(useState(true), 2), isFirstRender = _b[0], setIsFirstRender = _b[1];
    var _c = __read(useState({
        left: 0,
        width: 0,
        duration: '0ms',
    }), 2), bgState = _c[0], setBgState = _c[1];
    useLayoutEffect(function () {
        if (activeEl.current) {
            var _a = activeEl.current, left = _a.offsetLeft, width = _a.offsetWidth;
            setBgState({ left: left, width: width, duration: isFirstRender ? '0ms' : '200ms' });
            if (isFirstRender) {
                setIsFirstRender(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, fixedWidths]);
    useEffect(function () {
        if (!fixedWidths || !window)
            return;
        var handleResize = function () {
            if (activeEl.current) {
                var _a = activeEl.current, left = _a.offsetLeft, width = _a.offsetWidth;
                setBgState({ left: left, width: width, duration: '0ms' });
            }
        };
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, [fixedWidths]);
    var handleChange = useCallback(function (newValue) {
        if (!disabled && newValue !== value && onChange) {
            onChange(newValue);
        }
    }, [value, disabled, onChange]);
    return (React.createElement(Root, { "$disabled": disabled, "$fixedWidths": fixedWidths, "aria-disabled": disabled, className: className, onKeyPress: function (event) {
            var enabledOptions = options.filter(function (_a) {
                var disabledOption = _a.disabled;
                return !disabledOption;
            });
            var index = enabledOptions.findIndex(function (option) { return option.value === value; });
            if ((event.key === 'ArrowRight' || event.key === 'ArrowDown') &&
                index < enabledOptions.length - 1) {
                handleChange(enabledOptions[index + 1].value);
                setTimeout(function () {
                    var _a;
                    (_a = activeEl.current) === null || _a === void 0 ? void 0 : _a.focus();
                });
                return;
            }
            if ((event.key === 'ArrowLeft' || event.key === 'ArrowUp') && index > 0) {
                handleChange(enabledOptions[index - 1].value);
                setTimeout(function () {
                    var _a;
                    (_a = activeEl.current) === null || _a === void 0 ? void 0 : _a.focus();
                });
            }
        }, role: "radiogroup", style: style },
        options.map(function (_a) {
            var disabledOption = _a.disabled, label = _a.label, optionValue = _a.value;
            return (React.createElement(Segment, { key: label, "$active": value === optionValue, "$disabled": disabled || disabledOption, "$fixedWidths": fixedWidths, "aria-checked": value === optionValue, "aria-disabled": disabled || disabledOption, onClick: function () {
                    if (!disabledOption) {
                        handleChange(optionValue);
                    }
                }, onKeyPress: function (event) {
                    if (!disabledOption && event.key === ' ') {
                        handleChange(optionValue);
                        setTimeout(function () {
                            var _a;
                            (_a = activeEl.current) === null || _a === void 0 ? void 0 : _a.focus();
                        });
                    }
                }, ref: value === optionValue ? activeEl : null, role: "radio", tabIndex: 0 },
                React.createElement(ItemLabel, null, label),
                React.createElement(ItemOverlayLabel, { "$disabled": disabled || disabledOption, "$show": value === optionValue, "aria-hidden": true }, label),
                React.createElement(FocusIndicator, null)));
        }),
        React.createElement(SegmentBackground, { "$disabled": disabled, "$duration": bgState.duration, "$left": bgState.left, "$width": bgState.width })));
};
export default SegmentedControl;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=SegmentedControl.js.map